<template>
  <div id="JobDetail">
    <div class="banner container-fuild text-center">职位详情</div>
    <!-- 面包屑 -->
    <div class="container">
      <div class="breadcrumb">
        <router-link to="/" class="breadcrumb-item">首页</router-link>
        <span class="separator">/</span>
        <router-link to="/job-chance" class="breadcrumb-item">职位列表</router-link>
        <span class="separator">/</span>
        <span class="breadcrumb-item active">职位详情</span>
      </div>
      <div class="job-header">
        <h1 class="job-title">{{ jobInfo.title }}</h1>
        <div class="job-tags">
          <span v-if="formattedJobInfo.typeText">{{ formattedJobInfo.typeText }}</span>
          <span v-if="formattedJobInfo.categoryText">{{ formattedJobInfo.categoryText }}</span>
          <span v-if="jobInfo.field">{{ jobInfo.field }}</span>
          <span v-if="jobInfo.location">{{ jobInfo.location }}</span>
          <span class="post-date" v-if="jobInfo.postDate">发布于 {{ jobInfo.postDate }}</span>
          <span v-if="jobInfo.popular" class="hot-tag">热</span>
        </div>
        <button class="apply-btn" @click="showApplyModal">申请职位</button>
      </div>

      <div class="job-content">
        <section class="job-section">
          <h2 class="section-title">职位描述</h2>
          <div class="section-content">
            <div v-html="jobInfo.content"></div>
          </div>
        </section>

        <section class="job-section">
          <h2 class="section-title">职位信息</h2>
          <div class="job-info">
            <div class="info-row">
              <div class="info-item">
                <div class="info-label">职位名称</div>
                <div class="info-value">{{ jobInfo.title }}</div>
              </div>
              <div class="info-item">
                <div class="info-label">薪资范围</div>
                <div class="info-value">{{ formattedJobInfo.salaryText }}</div>
              </div>
              <div class="info-item">
                <div class="info-label">职位性质</div>
                <div class="info-value">{{ formattedJobInfo.typeText }}</div>
              </div>
              <div class="info-item">
                <div class="info-label">职能类型</div>
                <div class="info-value">{{ formattedJobInfo.categoryText }}</div>
              </div>
            </div>
            <div class="info-row">
              <div class="info-item">
                <div class="info-label">所属部门</div>
                <div class="info-value">{{ jobInfo.departmentName }}</div>
              </div>
              <div class="info-item">
                <div class="info-label">工作地点</div>
                <div class="info-value">{{ jobInfo.location }}</div>
              </div>
              <div class="info-item">
                <div class="info-label">发布日期</div>
                <div class="info-value">{{ jobInfo.postDate }}</div>
              </div>
              <div class="info-item"></div>
            </div>
          </div>
          <div class="apply-btn-container">
            <button class="apply-btn-center" @click="showApplyModal">申请职位</button>
          </div>
        </section>
      </div>
    </div>
    <div v-if="loading" class="loading-overlay">
      <div class="loading-spinner"></div>
    </div>
    <job-apply-modal ref="applyModal" :job-id="infoId"></job-apply-modal>
  </div>
</template>

<script>
import { workPositionInfo } from '@/api/api'
import JobApplyModal from '@/components/JobApplyModal.vue'

export default {
  name: 'JobDetail',
  components: {
    JobApplyModal
  },
  data() {
    return {
      jobInfo: {
      },
      loading: false,
      form: {
        type: '',
        category: '',
        salary: ''
      },
      typeOptions: [
        { label: '全职', value: '1' },
        { label: '兼职', value: '2' },
        { label: '实习', value: '3' }
      ],
      categoryOptions: [
        { label: '技术', value: '1' },
        { label: '产品', value: '2' },
        { label: '设计', value: '3' },
        { label: '运营', value: '4' },
        { label: '市场', value: '5' }
      ],
      salaryOptions: [
        { label: '面议', value: '0' },
        { label: '3k-5k', value: '1' },
        { label: '5k-10k', value: '2' },
        { label: '10k-15k', value: '3' },
        { label: '15k-20k', value: '4' },
        { label: '20k以上', value: '5' }
      ],
      infoId:0,
    }
  },
  computed: {
    // 将数字值转换为对应的中文标签
    formattedJobInfo() {
      if (!this.jobInfo) return {};

      let typeLabel = '';
      let categoryLabel = '';
      let salaryLabel = '';

      // 查找对应的标签
      for (let option of this.typeOptions) {
        if (option.value === this.jobInfo.type) {
          typeLabel = option.label;
          break;
        }
      }

      for (let option of this.categoryOptions) {
        if (option.value === this.jobInfo.category) {
          categoryLabel = option.label;
          break;
        }
      }

      for (let option of this.salaryOptions) {
        if (option.value === this.jobInfo.salary) {
          salaryLabel = option.label;
          break;
        }
      }

      return {
        ...this.jobInfo,
        typeText: typeLabel,
        categoryText: categoryLabel,
        salaryText: salaryLabel
      };
    }
  },
  created() {
    //获取职位列表传递的数据
    //接收父组件传的值
    this.infoId = this.$route.query.id;
    this.initInfo();
  },
   
  methods: {
    initInfo() {
      workPositionInfo(this.infoId).then(res => {
        this.jobInfo = res.data
      })
    },
    showApplyModal() {
      this.$refs.applyModal.show()
    }
  }
}
</script>

<style scoped>
.banner {
  color: #fff;
  font-size: 30px;
  height: 120px;
  line-height: 120px;
  background-image: url("../assets/img/banner_2.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}

.breadcrumb {
  padding: 16px 0;
  font-size: 14px;
  color: #666;
  display: flex;
  align-items: center;
  line-height: 1;
  margin-bottom: 5px;
}

.breadcrumb-item {
  text-decoration: none;
  color: #666;
  transition: color 0.3s ease;
  position: relative;
  display: inline-flex;
  align-items: center;
}

.breadcrumb-item:hover {
  color: #1890ff;
}

.breadcrumb-item.active {
  color: #333;
  font-weight: 500;
}

.separator {
  margin: 0 10px;
  color: #d9d9d9;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
}

.job-header {
  padding: 20px 0;
  border-bottom: 1px solid #eee;
  position: relative;
}

.job-title {
  font-size: 24px;
  color: #333;
  margin-bottom: 10px;
}

.job-tags {
  margin: 8px 0;
}

.job-tags span {
  margin-right: 15px;
  margin-bottom: 5px;
  display: inline-block;
  color: #666;
}

.hot-tag {
  background-color: #ff4d4f;
  color: white !important;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.apply-btn {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  padding: 10px 30px;
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
}

.apply-btn:hover {
  background-color: #40a9ff;
}

.job-content {
  padding: 20px 0;
}

.job-section {
  margin-bottom: 20px;
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.section-title {
  font-size: 18px;
  color: #333;
  margin-bottom: 15px;
  font-weight: bold;
  position: relative;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.section-title::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 50px;
  height: 2px;
  background-color: #1890ff;
}

.section-content {
  color: #666;
  line-height: 1.6;
  font-size: 15px;
}

.section-content h3 {
  font-size: 16px;
  color: #333;
  margin: 15px 0 12px;
  font-weight: 600;
  position: relative;
  padding-left: 12px;
}

.section-content h3:first-child {
  margin-top: 0;
}

.section-content h3::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 16px;
  background-color: #1890ff;
  border-radius: 2px;
}

.section-content ul {
  padding-left: 16px;
  margin-bottom: 15px;
  list-style-type: none;
}

.section-content li {
  margin-bottom: 10px;
  position: relative;
  padding-left: 20px;
  line-height: 1.5;
}

.section-content li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 8px;
  width: 6px;
  height: 6px;
  background-color: #1890ff;
  border-radius: 50%;
}

.section-content p {
  margin-bottom: 15px;
  line-height: 1.8;
}

.job-info {
  margin-top: 15px;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

.info-row {
  display: flex;
  margin-bottom: 15px;
}

.info-row:last-child {
  margin-bottom: 0;
}

.info-item {
  flex: 1;
  padding: 0 12px;
  border-right: 1px solid #eee;
}

.info-item:first-child {
  padding-left: 0;
}

.info-item:last-child {
  padding-right: 0;
  border-right: none;
}

.info-label {
  color: #999;
  font-size: 14px;
  margin-bottom: 6px;
  font-weight: 500;
}

.info-value {
  color: #333;
  font-size: 15px;
  font-weight: 500;
}

.post-date {
  color: #999;
}

.apply-btn-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.apply-btn-center {
  padding: 10px 30px;
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
}

.apply-btn-center:hover {
  background-color: #40a9ff;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #1890ff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

@media screen and (max-width: 768px) {
  .banner {
    height: 100px;
    line-height: 100px;
    font-size: 24px;
  }

  .breadcrumb {
    padding: 12px 15px;
    font-size: 13px;
    margin-bottom: 0;
  }

  .separator {
    margin: 0 8px;
  }

  .job-header {
    padding: 15px;
  }

  .job-title {
    font-size: 22px;
    margin-bottom: 8px;
  }

  .job-tags {
    margin-bottom: 12px;
  }

  .job-tags span {
    margin-right: 12px;
    margin-bottom: 8px;
    font-size: 16px;
    padding: 4px 12px;
    background: #f5f5f5;
    border-radius: 4px;
  }

  .job-tags span.hot-tag {
    background-color: #ff4d4f !important;
    color: white !important;
    font-size: 16px;
    padding: 4px 12px;
    border-radius: 4px;
    font-weight: 500;
  }

  .apply-btn {
    position: static;
    transform: none;
    width: 100%;
    padding: 12px 0;
    font-size: 18px;
    margin-top: 15px;
  }

  .job-section {
    padding: 15px;
    margin-bottom: 15px;
  }

  .section-title {
    font-size: 20px;
    padding-bottom: 10px;
    margin-bottom: 12px;
  }

  .section-content {
    font-size: 16px;
  }

  .section-content h3 {
    font-size: 18px;
    margin: 15px 0 10px;
  }

  .section-content li {
    margin-bottom: 8px;
  }

  .job-info {
    padding: 12px;
    margin-top: 12px;
  }

  .info-row {
    flex-direction: column;
    margin-bottom: 0;
  }

  .info-item {
    flex: 1;
    width: 100%;
    margin-bottom: 15px;
    padding: 0;
    border-right: none;
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 12px;
  }

  .info-item:last-child {
    margin-bottom: 0;
    border-bottom: none;
    padding-bottom: 0;
  }

  .info-label {
    font-size: 16px;
    margin-bottom: 6px;
    color: #666;
  }

  .info-value {
    font-size: 18px;
    color: #333;
  }

  .apply-btn-container {
    margin-top: 20px;
  }

  .apply-btn-center {
    width: 100%;
    padding: 12px 0;
    font-size: 18px;
  }
}

@media screen and (max-width: 480px) {
  .banner {
    height: 80px;
    line-height: 80px;
    font-size: 22px;
  }

  .breadcrumb {
    padding: 10px 12px;
    font-size: 12px;
  }

  .separator {
    margin: 0 6px;
    font-size: 10px;
  }

  .job-header {
    padding: 12px;
  }

  .job-title {
    font-size: 20px;
  }

  .job-tags span {
    font-size: 15px;
    padding: 3px 10px;
  }

  .job-tags span.hot-tag {
    font-size: 15px;
    padding: 3px 10px;
    background-color: #ff4d4f !important;
    color: white !important;
  }

  .section-title {
    font-size: 18px;
    padding-bottom: 8px;
    margin-bottom: 10px;
  }

  .section-content {
    font-size: 16px;
  }

  .section-content h3 {
    font-size: 17px;
  }

  .info-label {
    font-size: 15px;
  }

  .info-value {
    font-size: 17px;
  }

  .apply-btn,
  .apply-btn-center {
    font-size: 17px;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/JobDetail.vue